import { Page, Section } from 'ui';

import { SupportIssueForm } from '../../components/SupportIssueForm/SupportIssueForm';
import { useSupportIssueTitle } from '../../hooks/useSupportIssueTitle/useSupportIssueTitle';

export const SupportTicketCreate = () => {
  const title = useSupportIssueTitle();

  return (
    <Page>
      <Page.Title title={title} />
      <Page.Divider />
      <Section>
        <SupportIssueForm />
      </Section>
    </Page>
  );
};
